import type { AllRouteEndpoints } from "../routeTypes";
export const legacyCatalogAccountFields = "/apps/business/account_fields";

export const appsLegacyCatalogAccountFieldsCacheKeys: AllRouteEndpoints[] = ["/apps/business/account_fields"];
